import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

const Header = ({ siteTitle }) => (
  <header
    style={{
      background: `#000080`,
      marginBottom: `1.45rem`,
    }}
  >
    <div
      style={{
        margin: `0 auto`,
        maxWidth: 960,
        padding: `1.45rem 1.0875rem`,
      }}
    >
      <h1 style={{ margin: 0 }}>
        <Link
          to="/"
          style={{
            color: `white`,
            textDecoration: `none`,
          }}
        >
          Jaffe Engineering
        </Link>
      </h1>
	<h2 style={{ margin: 0 }}>
        <Link
          to="/articles/impressum"
          style={{
            color: `white`,
            textDecoration: `none`,
          }}
        >
	Impressum
        </Link>
      </h2>
	<h2 style={{ margin: 0 }}>
        <Link
          to="/page-2"
          style={{
            color: `white`,
            textDecoration: `none`,
          }}
        >
	About
        </Link>
      </h2>

    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
